import React from 'react';
import useConfig from '../hooks/useConfig';

export default function OperatorLogin({ autoStart = false, attemptId, operator }) {
  const { config, loading, error } = useConfig();
  const autoStartedRef = React.useRef(false);

  const handleLogin = React.useCallback(async () => {
    if (!config) return;

    sessionStorage.setItem('operator', operator);
    if (attemptId) {
      sessionStorage.setItem('attemptId', attemptId);
    }

    const operatorEndpoints = {
      paddypower: config.paddypowerLoginUrl || 'https://identitysso.paddypower.com/view/login?product=foe&url=https%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
      skybet: config.skybetLoginUrl || 'https://identitysso.skybet.com/view/login?product=foe&url=https%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
      betfair: config.betfairLoginUrl || 'https://identitysso.betfair.com/view/login?product=foe&url=https%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
    };

    const authUrl = operatorEndpoints[operator.toLowerCase()] || config.authEndpoint;
    window.location.href = authUrl;
  }, [config, operator, attemptId]);

  React.useEffect(() => {
    if (autoStart && config && !autoStartedRef.current) {
      autoStartedRef.current = true;
      handleLogin();
    }
  }, [autoStart, config, handleLogin]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <p className="text-white text-lg">Loading configuration...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="bg-red-800 text-white p-6 rounded-lg max-w-md">
          <h2 className="text-xl font-bold mb-2">Configuration Error</h2>
          <p>{error}</p>
          <p className="mt-2 text-sm text-red-200">
            Ensure your <code>.env.local</code> or <code>.env.development</code> file is configured.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
      <div
        role="status"
        aria-label="Redirecting to Operator sign-in"
        className="w-12 h-12 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin"
      />
      <span className="sr-only">Redirecting to Operator sign-in...</span>
    </div>
  );
}
